import { gql } from "@apollo/client";

// No secret here: the server returns it only from create and rotate.
export const WEBHOOK_ENDPOINT_FRAGMENT = gql`
  fragment WebhookEndpointFields on WebhookEndpoint {
    id
    url
    events
    status
    revision
    createdAt
    updatedAt
  }
`;

export const GET_WEBHOOK_ENDPOINTS = gql`
  ${WEBHOOK_ENDPOINT_FRAGMENT}
  query webhookEndpoints {
    webhookEndpoints {
      ...WebhookEndpointFields
    }
  }
`;

export const GET_WEBHOOK_EVENT_TYPES = gql`
  query webhookEventTypes {
    webhookEventTypes
  }
`;

export const CREATE_WEBHOOK_ENDPOINT = gql`
  ${WEBHOOK_ENDPOINT_FRAGMENT}
  mutation createWebhookEndpoint($input: CreateWebhookEndpointInput!) {
    createWebhookEndpoint(input: $input) {
      webhookEndpoint {
        ...WebhookEndpointFields
      }
      secret
    }
  }
`;

export const UPDATE_WEBHOOK_ENDPOINT = gql`
  ${WEBHOOK_ENDPOINT_FRAGMENT}
  mutation updateWebhookEndpoint(
    $id: ID!
    $input: UpdateWebhookEndpointInput!
  ) {
    updateWebhookEndpoint(id: $id, input: $input) {
      ...WebhookEndpointFields
    }
  }
`;

export const DELETE_WEBHOOK_ENDPOINT = gql`
  ${WEBHOOK_ENDPOINT_FRAGMENT}
  mutation deleteWebhookEndpoint($id: ID!) {
    deleteWebhookEndpoint(id: $id) {
      ...WebhookEndpointFields
    }
  }
`;

export const ROTATE_WEBHOOK_SECRET = gql`
  ${WEBHOOK_ENDPOINT_FRAGMENT}
  mutation rotateWebhookSecret($id: ID!) {
    rotateWebhookSecret(id: $id) {
      webhookEndpoint {
        ...WebhookEndpointFields
      }
      secret
    }
  }
`;
